import {booleanAttribute, Directive, HostListener, inject, input} from '@angular/core';
import {NgControl} from '@angular/forms';

// Replacement for the CSP-blocked `oninput="this.value = this.value.toUpperCase()"`.
// Usage: <input appUppercase formControlName="country" />
// Data-driven forms can bind it: <input [appUppercase]="filter.uppercase" ... />
@Directive({
    selector: '[appUppercase]',
    standalone: true,
})
export class UppercaseDirective {
    private readonly ngControl = inject(NgControl, {optional: true, self: true});

    readonly isEnabled = input(true, {alias: 'appUppercase', transform: booleanAttribute});

    @HostListener('input', ['$event'])
    onInput(event: Event): void {
        if (!this.isEnabled()) {
            return;
        }
        const target = event.target;
        if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLTextAreaElement)) {
            return;
        }
        const upper = target.value.toUpperCase();
        if (target.value === upper) {
            return;
        }
        const start = target.selectionStart;
        const end = target.selectionEnd;
        target.value = upper;
        if (start !== null && end !== null) {
            target.setSelectionRange(start, end);
        }
        if (this.ngControl?.control != null && this.ngControl.control.value !== upper) {
            this.ngControl.control.setValue(upper);
        }
    }
}
